const AUTH_SCOPED_LOCAL_PREFIXES = [
  "gps:",
  "devices-full:",
  "devices-lite-v3:",
];

const AUTH_SCOPED_LOCAL_KEYS = [
  "individualDashboardActiveTab",
  "groupAdminDashboardActiveTab",
  "groupAdminSelectedDevices",
];

const AUTH_SCOPED_SESSION_KEYS = [
  "adminDashboardActiveTab",
];

const removeMatchingStorageEntries = (storage, { prefixes = [], keys = [] } = {}) => {
  if (!storage) return;

  try {
    [...keys].forEach((key) => storage.removeItem(key));

    const removals = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (!key) continue;
      if (prefixes.some((prefix) => key.startsWith(prefix))) {
        removals.push(key);
      }
    }
    removals.forEach((key) => storage.removeItem(key));
  } catch (error) {
    console.warn("[AUTH-SESSION] Failed to clear scoped storage", error);
  }
};

export const clearAuthScopedClientState = () => {
  if (typeof window === "undefined") return;

  removeMatchingStorageEntries(window.localStorage, {
    prefixes: AUTH_SCOPED_LOCAL_PREFIXES,
    keys: AUTH_SCOPED_LOCAL_KEYS,
  });

  removeMatchingStorageEntries(window.sessionStorage, {
    keys: AUTH_SCOPED_SESSION_KEYS,
  });
};
